export default __webpack_public_path__ + "static/media/Improved-UI.03ab478a.png";